import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { connect } from "react-redux";
import { withAuth0 } from "@auth0/auth0-react";

import { ClearError, SetError, setIsReferralFormfetchingFunc } from "../../redux-store/actions";
import Spinner from "react-bootstrap/Spinner";
import { useAuth0 } from "@auth0/auth0-react";
import DemoCarousel from "./CarouselImage";
import { API_URL, WORKFLOW_FILTER } from "../../ConstVariable";
const ReferralView = (props) => {
    const { getAccessTokenSilently } = useAuth0();
    const [srcData, setSrcData] = useState([]);

    const state = useSelector((state) => state);
    let selectedConversationId = state.SelectedConversationId;
    let isReferralFormPresent = state.ReferralFormPresent;

    async function fetchData(conversation_id) {
        if (conversation_id === null || conversation_id !== selectedConversationId) {
            return;
        }
        setSrcData(() => [])

        // props.setIsReferralFormfetchingFunc(true)
        const vEngageBackend = axios.create({
            baseURL: `${API_URL}`,
            headers: {
                Authorization: `Bearer ${await getAccessTokenSilently()}`,
            },
            withCredentials: true
        });
        vEngageBackend
            .get(`/oi/api/v1/referral-form-view/${conversation_id}`)
            .then((response) => {
                if (
                    response != null &&
                    response.hasOwnProperty("data") &&
                    response.data.hasOwnProperty("error_code") &&
                    response.data.error_code != 0 &&
                    response.data.error_code !== "100" //To avoid to show the warning added a condition on code "100", Ui get this code when does not get any referal form ,example:- receive the [] empty array at this code status,
                ) {
                    props.SetErrorForDisplay({
                        severity: "warning",
                        message: response.data.error_description,
                    });
                    return;
                }

                // Checking selected conversation id = response's conversstion id 
                if (response.data.conversation_id === selectedConversationId) {
                    console.log("conversation_id", response.data.conversation_id, selectedConversationId)
                    let data = [];
                    response.data.files.map((file, index) => {
                        data.push({
                            src: `${API_URL}${file.src}`,
                            title: file.title,
                            referral_id:file.referral_id,
                            backup_available:file.backup_available
                        });
                    });
                    setSrcData(data);
                    props.setIsReferralFormfetchingFunc(false)

                } else {
                    setSrcData(() => [])
                }

            })
            .catch((error) => {
                props.setIsReferralFormfetchingFunc(false)

                props.SetErrorForDisplay({
                    severity: "warning",
                    message: error.message,
                });
            });
    }

    useEffect(() => {
        return () => {
            setSrcData([])
        }
    }, [selectedConversationId])

    // useEffect(() => {
    //   // setSrcData([]);
    //   if (props.conversation_id) {
    //     fetchData(props.conversation_id);
    //   }
    // }, [selectedConversationId, props.conversation_id]);

    let srcDataLength = srcData.length;
    useEffect(() => {
        if (
            srcDataLength === 0 &&
            (isReferralFormPresent === "Available" || isReferralFormPresent === "Processed") &&
            props.conversation_id
        ) {
            fetchData(props.conversation_id);
        }


    }, [isReferralFormPresent, srcDataLength, props.conversation_id]);
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                // alignItems: "center",
                alignContent: "center",
                verticalAlign: "center",
            }}
        >
            {srcData.length === 0 && (
                <div
                    style={{
                        width: "100px",
                        height: "100px",
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        top: "190px",
                    }}
                >
                    <Spinner
                        animation="border"
                        role="status"
                        style={{ width: "100px", height: "100px" }}
                    >
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            )}
            {srcData.length > 0 && selectedConversationId === props.conversation_id && (
                <div
                    style={{
                        // display: "flex",
                        // justifyContent: "center",
                        // alignItems: "center",
                        width: "100%"
                    }}
                >
                    {/* <PhotoViewer Src={Src} /> */}
                    {/* <img src={src} alt="images" /> */}
                    <DemoCarousel Sources={srcData} />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        errorForDisplay: state.Error,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        SetErrorForDisplay: (payload) => dispatch(SetError(payload)),
        setIsReferralFormfetchingFunc: (data) => dispatch(setIsReferralFormfetchingFunc(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth0(ReferralView));
